<template>
  <div class="pre-lander" />
</template>

<script>

/**
 * Vue: Pre-Lander (pre-lander)
 * -----------------------------------------------------------------------------
 * Pre-Lander that shows for specific traffic sources.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
export default {
  name: 'PreLander',

  mounted() {
    window._conv_q = window._conv_q || []
    window._conv_q.push(["executeExperiment","1004129771"])

    // If AB test is a pass uncomment the next line.
    // this.checkTraffic()
  },

  methods: {

    /**
     * Hide's the spacer above PDP.
     */
    hideSpacer() {
      const spacer = document.querySelector('.site-header-offset')

      spacer.style.display = 'none'
    },

    /**
     * Checks wheather or not traffic source should see the banner.
     */
    checkTraffic() {
      const component = document.querySelector('.pre-lander')
      if (!component) return;

      const paramsString = component.getAttribute('data-url-params')
      if (!paramsString) return;
      const paramsArray = paramsString.split(',').map(param => param.trim())
      const searchParams = window.location.search.substring(1).split('&');

      if (!paramsString) return

      for (const param of paramsArray) {
        if (searchParams.includes(param)) {
          component.classList.remove('pre-lander__hide');
          component.style.display = 'block';
          this.hideSpacer();
          break;
        }
      }
    }
  },
}
</script>

<style lang="scss">
@import './pre-lander';
</style>
